var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.cssVars)},[_c('button',{staticClass:"button-box",attrs:{"type":_vm.type,"disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading && !_vm.disableLoading)?_c('div',[_c('v-progress-circular',{attrs:{"size":25,"color":"white","indeterminate":""}})],1):_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }